module.exports = __webpack_public_path__ + "static/media/nebo-logo.5092be33.svg";